export default __webpack_public_path__ + "static/media/mastermind.fb648c5c.png";